import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import FavoriteIcon from "@mui/icons-material/Favorite";

const Contacts: React.FC = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Create mailto link
    const mailtoLink = `mailto:sharmashashi940@gmail.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(message)}`;

    window.location.href = mailtoLink;
  };

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, mb: 4, textAlign: "center" }}
      >
        Would love to hear from you!
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 600,
          mx: "auto",
          mb: 6,
        }}
      >
        <TextField
          fullWidth
          label="Subject"
          multiline
          rows={2}
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="What's this about?"
          required
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Message"
          multiline
          rows={5}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Your message..."
          required
          sx={{ mb: 3 }}
        />

        <Button
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          endIcon={<SendIcon />}
        >
          Send Message
        </Button>
      </Box>

      <Card
        sx={{
          maxWidth: 600,
          mx: "auto",
          background:
            "linear-gradient(135deg, rgba(145, 189, 58, 0.1) 0%, rgba(145, 189, 58, 0.05) 100%)",
          border: "1px solid",
          borderColor: "primary.main",
        }}
      >
        <CardContent sx={{ textAlign: "center", py: 4 }}>
          <FavoriteIcon sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
            Like what you see?
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            A small contribution helps keep the work going.
          </Typography>
          <Button
            component={RouterLink}
            to="/support"
            variant="contained"
            size="large"
          >
            Support
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Contacts;
